module.exports = __webpack_public_path__ + "static/img/about-banner.785e36dd.png";